"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../index"));

var _validator = _interopRequireDefault(require("./validator"));

var _EventHandler = _interopRequireDefault(require("./EventHandler"));

var _InputError = _interopRequireDefault(require("../shared/InputError"));

/* eslint-disable max-lines-per-function, jsx-a11y/label-has-associated-control */
var RatingInput = function RatingInputControl(props) {
  if (props.customControlRenderer) {
    return props.customControlRenderer(props);
  }

  return defaultControlRenderer(props);
};

RatingInput.displayName = 'RatingInputControl';

var defaultControlRenderer = function defaultRatingControlRenderer(_ref) {
  var storedValue = _ref.storedValue,
      isValid = _ref.isValid,
      complete = _ref.complete,
      fieldData = _ref.fieldData,
      classPrefix = _ref.classPrefix,
      eventHandler = _ref.eventHandler;

  var generateValues = function generateValues(min, max) {
    var values = [];

    for (var i = max; i >= min; i--) {
      values.push(i.toString());
    }

    return values;
  };

  var _fieldData$control = fieldData.control,
      controlOptions = _fieldData$control.options,
      controlIcon = _fieldData$control.icon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__wrapper")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__question")
  }, fieldData.label), fieldData.instructions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__instructions")
  }, fieldData.instructions), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__answers")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__icon-rating")
  }, generateValues(controlOptions.min, controlOptions.max).map(function (val) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: val
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      id: "".concat(fieldData.fieldKey, "-").concat(val, "-icon"),
      name: fieldData.fieldKey,
      value: val,
      tabIndex: 0,
      checked: storedValue === val,
      onKeyPress: function onKeyPress(event) {
        return eventHandler.onKeyPress(event);
      },
      onChange: function onChange(event) {
        return eventHandler.onChange(event);
      },
      className: "".concat(classPrefix, "__input")
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "".concat(fieldData.fieldKey, "-").concat(val, "-icon"),
      className: "".concat(classPrefix, "__icon-").concat(controlIcon || 'star')
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    showError: !isValid && complete,
    classPrefix: classPrefix,
    message: fieldData.validation.message
  }));
};

defaultControlRenderer.propTypes = {
  storedValue: _propTypes["default"].string.isRequired,
  isValid: _propTypes["default"].bool.isRequired,
  dirty: _propTypes["default"].bool.isRequired,
  // eslint-disable-line
  complete: _propTypes["default"].bool.isRequired,
  classPrefix: _propTypes["default"].string.isRequired,
  eventHandler: _propTypes["default"].shape({
    handleUpdate: _propTypes["default"].func.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    onKeyPress: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired
    }).isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired,
  customControlRenderer: _propTypes["default"].func // eslint-disable-line

};
defaultControlRenderer.defaultProps = {
  customControlRenderer: null
};

var _default = (0, _index["default"])(RatingInput, _validator["default"], _EventHandler["default"]);

exports["default"] = _default;